
export default {
  name: 'EoColumn',
  props: {
    /**
     * Width (from 0 to 12)
     */
    size: {
      type: [String, Number],
      default: null,
      validator: (value) => {
        return 0 <= Number(value) && Number(value) <= 12
      },
    },
    /**
     * Position of this column in respect to its siblings (from -6 to 6 or auto)
     */
    order: {
      type: [String, Number],
      default: null,
      validator: (value) => {
        return -6 <= Number(value) && Number(value) <= 6 || 'auto'
      },
    },
    /**
     * Width for viewports xs and up (from 0 to 12 or auto)
     */
    xsAndUp: {
      type: [String, Number, Object],
      default: null,
      validator: (value) => {
        if (typeof value === 'object') {
          return value.size !== undefined || value.order !== undefined
        } else {
          return 0 <= Number(value) && Number(value) <= 12 || 'auto'
        }
      },
    },
    /**
     * Width for viewports sm and up (from 0 to 12 or auto)
     */
    smAndUp: {
      type: [String, Number, Object],
      default: null,
      validator: (value) => {
        if (typeof value === 'object') {
          return value.size !== undefined || value.order !== undefined
        } else {
          return 0 <= Number(value) && Number(value) <= 12 || 'auto'
        }
      },
    },
    /**
     * Width for viewports md and up (from 0 to 12 or auto)
     */
    mdAndUp: {
      type: [String, Number, Object],
      default: null,
      validator: (value) => {
        if (typeof value === 'object') {
          return value.size !== undefined || value.order !== undefined
        } else {
          return 0 <= Number(value) && Number(value) <= 12 || 'auto'
        }
      },
    },
    /**
     * Width for viewports lg and up (from 0 to 12 or auto)
     */
    lgAndUp: {
      type: [String, Number, Object],
      default: null,
      validator: (value) => {
        if (typeof value === 'object') {
          return value.size !== undefined || value.order !== undefined
        } else {
          return 0 <= Number(value) && Number(value) <= 12 || 'auto'
        }
      },
    },
    /**
     * Width for viewports xl and up (from 0 to 12 or auto)
     */
    xlAndUp: {
      type: [String, Number, Object],
      default: null,
      validator: (value) => {
        return 0 <= Number(value) && Number(value) <= 12 || 'auto'
      },
    },
  },
  computed: {
    classes () {
      return {
        'eo-column': true,
        ['xsAndUp-' + this.sizeXsAndUp]: !!this.sizeXsAndUp || this.sizeXsAndUp == 0,
        ['smAndUp-' + this.sizeSmAndUp]: !!this.sizeSmAndUp || this.sizeSmAndUp == 0,
        ['mdAndUp-' + this.sizeMdAndUp]: !!this.sizeMdAndUp || this.sizeMdAndUp == 0,
        ['lgAndUp-' + this.sizeLgAndUp]: !!this.sizeLgAndUp || this.sizeLgAndUp == 0,
        ['xlAndUp-' + this.sizeXlAndUp]: !!this.sizeXlAndUp || this.sizeXlAndUp == 0,
        ['xsAndUp-order-' + this.negativeToN(this.orderXsAndUp)]: !!this.orderXsAndUp || this.orderXsAndUp == 0,
        ['smAndUp-order-' + this.negativeToN(this.orderSmAndUp)]: !!this.orderSmAndUp || this.orderSmAndUp == 0,
        ['mdAndUp-order-' + this.negativeToN(this.orderMdAndUp)]: !!this.orderMdAndUp || this.orderMdAndUp == 0,
        ['lgAndUp-order-' + this.negativeToN(this.orderLgAndUp)]: !!this.orderLgAndUp || this.orderLgAndUp == 0,
        ['xlAndUp-order-' + this.negativeToN(this.orderXlAndUp)]: !!this.orderXlAndUp || this.orderXlAndUp == 0,
      }
    },
    sizeXsAndUp () {
      return this.xsAndUp?.size || this.xsAndUp || this.size
    },
    sizeSmAndUp () {
      return this.smAndUp?.size || this.smAndUp
    },
    sizeMdAndUp () {
      return this.mdAndUp?.size || this.mdAndUp
    },
    sizeLgAndUp () {
      return this.lgAndUp?.size || this.lgAndUp
    },
    sizeXlAndUp () {
      return this.xlAndUp?.size || this.xlAndUp
    },
    orderXsAndUp () {
      return this.xsAndUp?.order || this.order
    },
    orderSmAndUp () {
      return this.smAndUp?.order
    },
    orderMdAndUp () {
      return this.mdAndUp?.order
    },
    orderLgAndUp () {
      return this.lgAndUp?.order
    },
    orderXlAndUp () {
      return this.xlAndUp?.order
    },
  },
  methods: {
    negativeToN (integer) {
      if (integer == null) return null
      return integer.toString().replace('-', 'n')
    },
  },
}
